module.exports = __webpack_public_path__ + "static/media/dialogue.d5318e58.svg";